import { API_V2 } from '../lib/axios';
import { IAffiliate } from '@clickster/constant-definitions/dist-esm/entities/affiliate/types';
import { fetchAllPaginated } from './utils/fetch-all-paginated';

const AFFILIATE_ENDPOINT = '/affiliates';

const list = async (params = {}) => {
  return fetchAllPaginated<IAffiliate>(API_V2, AFFILIATE_ENDPOINT, params);
};

const find = async (id: string, params = {}) => {
  const response = await API_V2.get<IAffiliate>(`${AFFILIATE_ENDPOINT}/${id}`, {
     params: {
       ...params,
     },
  });

  return response.data;
}

const update = async (data: IAffiliate) => {
  const response = await API_V2.put<IAffiliate>(`${AFFILIATE_ENDPOINT}/${data._id}`, data);

  return response.data;
}

const create = async (data: IAffiliate) => {
  const response = await API_V2.post<IAffiliate>(`${AFFILIATE_ENDPOINT}`, data);

  return response.data;
};

export const AffiliateService = {
  list,
  find,
  update,
  create,
};

